import { render, staticRenderFns } from "./SFooter.vue?vue&type=template&id=56ddb8e7&scoped=true"
import script from "./SFooter.vue?vue&type=script&lang=js"
export * from "./SFooter.vue?vue&type=script&lang=js"
import style0 from "./SFooter.vue?vue&type=style&index=0&id=56ddb8e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddb8e7",
  null
  
)

export default component.exports